import { combineReducers } from "redux"
import { reducer as formReducer } from "redux-form"
import { i18nState } from "redux-i18n"
import parcel from "./parcel"
import parcels from "./parcels"
import general from "./general"

// Combine reducers with routeReducer which keeps track of
// router state
const rootReducer = combineReducers({
  parcel,
  parcels,
  general,
  form: formReducer,
  i18nState,
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/data/reducers/index.js